export enum userTypes {
  Admin = 0,
  ClientManager = 1,
  CampaignManager = 2,
  ClientViewer = 3,
  ClientUser = 4,
  CampaignUser = 5,
  InternalViewer = 6,
}
